import { haveFilterQuery, paginator, haveSort } from '../common/auxFun'

const endpointsCenters = {
  LOAD: (centerType, franchiseExit, filter, sort, limit, skip) =>
    `/v1/centers${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}${centerType ? `&centerType=${centerType}` : ''}${`&franchiseExit=${franchiseExit}`}`,
  BY_ID: (id) => `/v1/centers/${id}`,
  CREATE: `/v1/centers/`,

  PROVINCES: '/v1/centers/provinces',

  COMERCIAL: {
    LOAD: (id, filter, sort, limit, skip) =>
      `/v1/centers/${id}/comercial-data${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    BY_ID: (id, rowId) => `/v1/centers/${id}/comercial-data/${rowId}`,
    CREATE: (id) => `/v1/centers/${id}/comercial-data`,
  },

  WORKERS: {
    LOAD: (id, filter, sort, limit, skip) =>
      `/v1/centers/${id}/workers${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  },

  TECHNICS: {
    BY_ID: (id) => `/v1/centers/${id}/tecnics`,
    UPDATE: (id) => `/v1/centers/${id}/tecnics`,
    ASPIRATORS: {
      CREATE: (id) => `/v1/centers/${id}/tecnics/aspirators`,
      BY_ID: (id, rowId) => `/v1/centers/${id}/tecnics/aspirators/${rowId}`,
    },
    TRACKS: {
      CREATE: (id) => `/v1/centers/${id}/tecnics/tracks`,
      BY_ID: (id, rowId) => `/v1/centers/${id}/tecnics/tracks/${rowId}`,
    },
    OTHERS: {
      CREATE: (id) => `/v1/centers/${id}/tecnics/others`,
      BY_ID: (id, rowId) => `/v1/centers/${id}/tecnics/others/${rowId}`,
    },
  },

  CONTRACTS: {
    LOAD: (id) => `/v1/centers/${id}/contracts`,
    UPLOAD: (id) => `/v1/centers/${id}/contracts/file`,
    FILE_BY_ID: ({ id, rowId }) => `/v1/centers/${id}/contracts/file/${rowId}`,
  },

  CONVENTIONS: {
    LOAD: (id) => `/v1/centers/${id}/conventions`,
    BY_ID: (id, rowId) => `/v1/centers/${id}/conventions/${rowId}`,
  },

  SERVICES: {
    LOAD: (id) => `/v1/centers/${id}/services`,
    BY_ID: (id, rowId) => `/v1/centers/${id}/services`,
  },

  MAINTENANCES: {
    LOAD: (id, filter, sort, limit, skip) =>
      `/v1/centers/${id}/maintenances${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    BY_ID: (id, rowId) => `/v1/centers/${id}/maintenances/${rowId}`,
    CREATE: (id) => `/v1/centers/${id}/maintenances`,
  },

  CASH_REGISTERS: {
    LOAD: (id, filter, sort, limit, skip) =>
      `/v1/centers/${id}/cash-registers${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    BY_ID: (id, rowId) => `/v1/centers/${id}/cash-registers/${rowId}`,
    CREATE: (id) => `/v1/centers/${id}/cash-registers`,
  },

  MANUALS: {
    // LOAD: (id) => `/v1/centers/${id}/manuals`,
    LOAD: (id, filter, sort, limit, skip) =>
      `/v1/centers/${id}/manuals${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
    UPLOAD: (id) => `/v1/centers/${id}/manuals`,
    BY_ID: (id, rowId) => `/v1/centers/${id}/manuals/${rowId}`,
    FILE_BY_ID: ({ id, rowId }) => `/v1/centers/${id}/manuals/${rowId}`,
    CREATE: (id) => `/v1/centers/${id}/manuals`,
  },
}

export default endpointsCenters
